<template>
    <div class="LogoMenu8Bit">
        <a href="/mylotto-rewards/club-promotions/8-bit-at-bat!"><img src="/getattachment/0985180a-a6f2-4f19-a509-2effe9874319/oh-logo.png" alt="OhioLottery"></a>
        <div>
            <button id="mobile-menu" class="menuLines8bit" @click="openMenu()"></button>
        </div>
        <div class="CashCatch-mobile-menu" id="CashCatch-mobile-menu">
            <div class="CashCatch-close"><span @click="closeMenu()" style="font-size:30px;cursor:pointer">&times;</span></div>
            <nav class="CashCatch-mobile-mainNav">
                <ul>
                    <li><a :href="GameURL">Play Now</a></li>
                    <li><a :href="HowToURL">How To Play</a></li>
                    <li><a href="/mylotto-rewards/club-promotions/8-bit-at-bat!">Terms and Conditions</a></li>
                    <li><a href="/about/about-the-ohio-lottery/legal/privacy-policy">Privacy Policy</a></li>
                </ul>
            </nav>
            <div class="CashCatch-menu-disclaimer">
                <img src="/getattachment/0985180a-a6f2-4f19-a509-2effe9874319/oh-logo.png" alt="OH Logo">
                <p>Ohio Problem Gambling Helpline</p>
                <p>800-589-9966</p>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
      data: function() {
          return {
            GameURL: '',
            HowToURL: '',
          }
      },
      mounted: function () {
            this.getTeam();
      },
      methods: {
          openMenu() {
              document.getElementById("CashCatch-mobile-menu").style.width = "100%";
          },
          closeMenu() {
              document.getElementById("CashCatch-mobile-menu").style.width = "0%";
          },
          getTeam() {
                let pathName = window.location.pathname;
                if (pathName.indexOf('reds') >= 0) {
                    this.GameURL = '/cash-catch-challenge-reds';
                    this.HowToURL = '/cash-catch-challenge-reds/how-to-play';
                } else {
                    this.GameURL = '/cash-catch-challenge-guardians';
                    this.HowToURL = '/cash-catch-challenge-guardians/how-to-play';
                }
            },
      }
  }
</script>
<style lang="scss"  scoped>
@import url('https://fonts.googleapis.com/css2?family=Bevan&family=Kanit:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
.LogoMenu8Bit{
  flex-shrink: 0;
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  padding:20px;
  width:100vw;
  z-index: 15;

  img{
    max-width: 80px;
  }
  .title-bar{
    scale: 1.5;
    #mobile-menu-icon::after{
      background: white;
      box-shadow: 0 6px 0 white, 0 12px 0 white;
      height:2px;
    }
  }
}


// menu icon
  #mobile-menu::after{
    content: "";
    width: 100%;
    background: white;
    box-shadow: 0 6px 0 white, 0 12px 0 white;
    height:2px;
  }
  .menuLines8bit{
    scale: 1.5;
    width:35px;
    cursor: pointer;
    color:white;
    margin-right: 15px;
    padding:0px;
  }

  //menu items
  .CashCatch-mobile-menu {
    height: 100%;
    position: fixed;
    width: 0;
    z-index: 1;
    top: 0;
    right: 0;
    background: linear-gradient(#05192E, #0E3F75);
    overflow-x: hidden;
    color: white;
    transition: 0.5s;
    box-shadow: 1px 2px 8px #000;

    .CashCatch-close {
        font-family: 'Kanit';
        padding-right: 20px;
        position: absolute;
        left: 30px;
    }

    .CashCatch-close span {
        font-family: 'Kanit';
        font-size: 15rem !important;
        font-weight: 100;
        line-height: 0.5em;
        color: #fff;
    }

    ul{
        margin:0px;
    }
    .CashCatch-mobile-mainNav {
        padding-bottom: 10px; 
        margin: 125px 30px;
    }

    nav ul li a {
        font-family: 'Kanit';
        color: #fff;
        font-size: 2.4rem;
        text-decoration: none;
        font-weight: 600;
        padding: 1em 10px;
        display: block;
        border-bottom: 1px solid #fff;
    }

    .CashCatch-menu-disclaimer {
        font-family: 'Kanit';
        padding: 30px;
        font-weight: 400;
        position: absolute;
        color: #fff;

        bottom: 0;
        img{
            margin-bottom: 20px;
            max-width: 90px;
        }
        p{
            font-family: 'Kanit';
            margin-bottom: 0px;
        }
    }
}

</style>